export default __webpack_public_path__ + "static/media/img-quizz-bg.6b27b848.svg";